<script setup lang="ts">
import { h, type PropType } from 'vue';
import { RouterLink, type RouteLocationRaw } from 'vue-router';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    default: '-',
  },
  multiline: {
    type: Boolean,
    default: false,
  },
  to: {
    type: Object as PropType<RouteLocationRaw>,
    default: undefined,
  },
});

const render = () => {
  const labelElement = h(
    'dt',
    {
      class: 'tw-text-sm tw-text-surface-500 dark:tw-text-neutral-400 tw-shrink-0 tw-pt-px',
    },
    props.label
  );

  let valueElement;
  const displayValue = props.value || '-';

  if (props.to) {
    valueElement = h(
      RouterLink,
      {
        to: props.to,
        class:
          'tw-text-sm tw-font-semibold tw-text-secondary-700 hover:tw-text-secondary-900 dark:tw-text-neutral-200 dark:hover:tw-text-white hover:tw-underline tw-underline-offset-2 tw-text-right',
      },
      () => displayValue
    );
  } else {
    valueElement = h(
      'dd',
      {
        class: [
          'tw-text-sm tw-font-semibold tw-text-secondary-900 dark:tw-text-neutral-100 tw-text-right',
          { 'tw-whitespace-pre-wrap tw-leading-relaxed': props.multiline },
        ],
      },
      displayValue
    );
  }

  return h(
    'div',
    {
      class:
        'tw-flex tw-justify-between tw-items-start tw-gap-6 tw-py-2.5 tw-border-b tw-border-surface-100 last:tw-border-b-0 dark:tw-border-neutral-800/60',
    },
    [labelElement, valueElement]
  );
};
</script>

<template>
  <render />
</template>
